import { mount, config, createLocalVue  } from '@vue/test-utils';
import Vuex from 'vuex';
import ProductIngredients from './ProductIngredients';

describe('ProductIngredients', () => {
  const actions = {
    "openProductIngredientsModal": jest.fn(),
  };

  const localVue = createLocalVue();
  localVue.use(Vuex);

  const store = new Vuex.Store({
    modules: {
      pdp: { 
        namespaced: true, 
        actions
      },
    }
  });

  config.mocks['windowData'] = {
    breakpoint: 'mobile' 
  };

  const createWrapper = () => {
    return mount(ProductIngredients, {
      store,
      localVue,
      propsData: {
        product: {}
      },
      stubs: {
        ProductIngredientsDetails: '<div class="stubbed"/>'
      },
    });
  };

  let wrapper = createWrapper();

  it('is implemented using Details/Summary widget', () => {
    /* caveats: 
    /  replaced with .details and button.summary because Details/Summary widget is not supported by Edge at the moment;
    /  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/details
    */
    const summary = wrapper.find('button.summary');
    expect(summary.element.parentElement.classList.contains('details')).toBe(true);
  });

  describe('toggle', () => {

    it('opens a modal on mobile device', ()=> {
      expect(wrapper.contains('.stubbed')).toBe(false);
      wrapper.find('button.summary').trigger('click'); 
      expect(actions.openProductIngredientsModal).toHaveBeenCalled();
    });
    
    it('shows or hides product ingredients details on desktop device', () => {
      wrapper.destroy();
      config.mocks['windowData'].breakpoint = 'desktop';
      wrapper = createWrapper();

      const widget = wrapper.find('.product-ingredients');
      expect(widget.element.classList.contains('open')).toBe(false);

      wrapper.find('button.summary').trigger('click');
      expect(widget.element.classList.contains('open')).toBe(true);
    });
  });

});
